import React, { useEffect, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import NoData from "../../component/NoData";

const DailyStreakChallenge = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    status: "active",
    page: 1,
    limit: 100,
  });

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getTurnover, filter);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
  };

  return (
    <AccountLayout title={t("DailyStreakChallenge")}>
      <div
        _ngcontent-serverapp-c3037944270
        className="content mcd-style player-content"
      >
        <div
          _ngcontent-serverapp-c1339057359
          className="daily-streak-challenge-container ng-star-inserted"
          style={{
            "background-image":
              'url("/assets/NewImages/bg-gradient.webp?v=1776751585885")',
          }}
        >
          <div
            _ngcontent-serverapp-c1339057359
            className="daily-streak-challenge-wrap"
          >
            <mcd-calendar
              _ngcontent-serverapp-c1339057359
              _nghost-serverapp-c2137178430
            >
              <div _ngcontent-serverapp-c2137178430 className="calendar">
                <div
                  _ngcontent-serverapp-c2137178430
                  className="calendar__daily-check-wrap is-one-row"
                >
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item today select ng-star-inserted"
                  >
                    <span
                      _ngcontent-serverapp-c2137178430
                      className="today-badge ng-star-inserted"
                    >
                      {" "}
                      {t("Today")}{" "}
                    </span>
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>1</strong>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item ng-star-inserted"
                  >
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>2</strong>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item ng-star-inserted"
                  >
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>3</strong>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item ng-star-inserted"
                  >
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>4</strong>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item ng-star-inserted"
                  >
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>5</strong>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item ng-star-inserted"
                  >
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>6</strong>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c2137178430
                    className="calendar__daily-item ng-star-inserted"
                  >
                    {/**/}
                    <div
                      _ngcontent-serverapp-c2137178430
                      className="calendar__daily-content"
                    >
                      {/**/}
                      <span
                        _ngcontent-serverapp-c2137178430
                        className="item-icon"
                        style={{
                          "background-image":
                            'url("/assets/NewImages/gift.webp?v=1776751585885")',
                        }}
                      />
                      <p _ngcontent-serverapp-c2137178430>{t("Day")}</p>
                      <strong _ngcontent-serverapp-c2137178430>7</strong>
                    </div>
                  </div>
                  {/**/}
                </div>
              </div>
            </mcd-calendar>
          </div>
          <div
            _ngcontent-serverapp-c1339057359
            className="prizes-requirement-wrapper"
          >
            {/**/}
            <div
              _ngcontent-serverapp-c1339057359
              className="prizes-requirement-content"
            >
              <div
                _ngcontent-serverapp-c1339057359
                className="daily-streak-area__prizes ng-star-inserted"
              >
                <mcd-prizes
                  _ngcontent-serverapp-c1339057359
                  _nghost-serverapp-c3967107000
                >
                  <div _ngcontent-serverapp-c3967107000 className="prizes-head">
                    <div
                      _ngcontent-serverapp-c3967107000
                      className="prizes-head__title content-title"
                    >
                      <h2 _ngcontent-serverapp-c3967107000>
                        <span _ngcontent-serverapp-c3967107000>
                          {t("Prizes")}
                        </span>
                      </h2>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c3967107000
                    className="prizes-inner"
                  >
                    <div
                      _ngcontent-serverapp-c3967107000
                      className="prize-item ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c3967107000
                        className="prize-item-inner"
                      >
                        <img
                          _ngcontent-serverapp-c3967107000
                          alt="pattern"
                          className="prize-item-pattern"
                          src="/assets/NewImages/pattern.webp?v=1776751585885&source=mcdsrc"
                          loading="lazy"
                        />
                        <img
                          _ngcontent-serverapp-c3967107000
                          alt="icon-prize"
                          className="prize-item-gift-bg"
                          src="/assets/NewImages/icon-prize.webp?v=1776751585885&source=mcdsrc"
                          loading="lazy"
                        />
                        <p
                          _ngcontent-serverapp-c3967107000
                          className="prize-item-title"
                        >
                          {t("DailyStreakChallengePrize")}
                        </p>
                      </div>
                      <div
                        _ngcontent-serverapp-c3967107000
                        className="prize-item-image-wrapper"
                      >
                        <svg
                          _ngcontent-serverapp-c3967107000
                          width={64}
                          height={48}
                          viewBox="0 0 64 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="prize-item-image-bg"
                        >
                          <path
                            _ngcontent-serverapp-c3967107000
                            d="M58.9911 0C61.2001 0.000128433 62.9911 1.79094 62.9911 4V44C62.9911 46.2091 61.2001 47.9999 58.9911 48H14.991L0.839682 26.7734C-0.279894 25.094 -0.279893 22.906 0.839682 21.2266L14.991 0H58.9911Z"
                            fill="#1A1A1A"
                          />
                        </svg>
                        <div
                          _ngcontent-serverapp-c3967107000
                          className="prize-item-image-bg-filter"
                        />
                        <img
                          _ngcontent-serverapp-c3967107000
                          className="prize-item-image"
                          alt="Daily Streak Challenge: 150 BDT"
                          src="/assets/NewImages/gift.webp?v=1776751585885&source=mcdsrc"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    {/**/}
                  </div>
                </mcd-prizes>
              </div>
              {/**/}
              <div
                _ngcontent-serverapp-c1339057359
                className="daily-streak-area__requirement ng-star-inserted"
              >
                <mcd-requirement
                  _ngcontent-serverapp-c1339057359
                  _nghost-serverapp-c3383180268
                >
                  <div
                    _ngcontent-serverapp-c3383180268
                    className="requirement-title content-title ng-star-inserted"
                  >
                    <h2 _ngcontent-serverapp-c3383180268>
                      <span _ngcontent-serverapp-c3383180268>
                        {t("Challenge")}
                      </span>
                    </h2>
                  </div>
                  {/**/}
                  <div
                    _ngcontent-serverapp-c3383180268
                    className="deposit-inner ng-star-inserted"
                  >
                    {/**/}
                    <span
                      _ngcontent-serverapp-c3383180268
                      className="requirement-icon"
                      style={{
                        "background-image":
                          'url("/assets/NewImages/white/deposit.webp?v=1776751585885")',
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c3383180268
                      className="requirement-number-group"
                    >
                      <p _ngcontent-serverapp-c3383180268 className="txt">
                        {" "}
                        {t("Deposit")}{" "}
                      </p>
                      <p _ngcontent-serverapp-c3383180268 className="number">
                        <i _ngcontent-serverapp-c3383180268>0</i>/1,500
                      </p>
                    </div>
                    <div
                      _ngcontent-serverapp-c3383180268
                      className="progress-bar"
                    >
                      <div _ngcontent-serverapp-c3383180268 className="bar">
                        <div
                          _ngcontent-serverapp-c3383180268
                          className="bar-inner"
                          style={{ width: "0%" }}
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3383180268
                      className="btn ng-star-inserted"
                    >
                      {t("DepositNow")}{" "}
                    </div>
                    {/**/}
                  </div>
                  {/**/}
                  <div
                    _ngcontent-serverapp-c3383180268
                    className="turnover-inner ng-star-inserted"
                  >
                    {/**/}
                    <span
                      _ngcontent-serverapp-c3383180268
                      className="requirement-icon"
                      style={{
                        "background-image":
                          'url("/assets/NewImages/white/turnover.webp?v=1776751585885")',
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c3383180268
                      className="requirement-number-group"
                    >
                      <p _ngcontent-serverapp-c3383180268 className="txt">
                        {" "}
                        {t("Turnover")}{" "}
                      </p>
                      <p _ngcontent-serverapp-c3383180268 className="number">
                        <i _ngcontent-serverapp-c3383180268>0</i>/10,000
                      </p>
                    </div>
                    <div
                      _ngcontent-serverapp-c3383180268
                      className="progress-bar"
                    >
                      <div _ngcontent-serverapp-c3383180268 className="bar">
                        <div
                          _ngcontent-serverapp-c3383180268
                          className="bar-inner"
                          style={{ width: "0%" }}
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3383180268
                      className="btn ng-star-inserted"
                    >
                      {t("PlayNow")}{" "}
                    </div>
                    {/**/}
                  </div>
                  {/**/}
                  <p
                    _ngcontent-serverapp-c3383180268
                    className="requirement-notice"
                  >
                    {" "}
                    {t("ChallengeProgressNotice")}
                  </p>
                </mcd-requirement>
              </div>
              {/**/}
              <div
                _ngcontent-serverapp-c1339057359
                className="daily-streak-challenges-bottom daily-streak-area__bottom ng-star-inserted"
              >
                <button
                  _ngcontent-serverapp-c1339057359
                  className="daily-streak-challenges-bottom__button button disabled"
                >
                  {" "}
                  {t("ClaimNow")}{" "}
                </button>
              </div>
              {/**/}
              {/**/}
            </div>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
};

export default DailyStreakChallenge;
